import { IWorkflowTemplateVersion } from '@commenda/types';
import { TBuilderConfirmation } from '../types/types';

export class WorkflowBuilderChatHelper {
  static getDiscardConfirmation(
    version: IWorkflowTemplateVersion,
    onConfirm: () => Promise<void>
  ): TBuilderConfirmation {
    return {
      title: `Discard draft ${version.version}?`,
      warnings: ['This cannot be undone.'],
      confirmLabel: 'Discard draft',
      onConfirm,
    };
  }
}
